import { render, staticRenderFns } from "./CompliancePortal.vue?vue&type=template&id=f9eeff2c&scoped=true"
import script from "./CompliancePortal.vue?vue&type=script&lang=js"
export * from "./CompliancePortal.vue?vue&type=script&lang=js"
import style0 from "./CompliancePortal.vue?vue&type=style&index=0&id=f9eeff2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9eeff2c",
  null
  
)

export default component.exports